import {
  TK_TIPOS_ACAO_SELECAO_SERVICO,
  trackServiceSelectORA
} from "../../shared/helper/tracker";

import { capitalize, formataEspecieBeneficio } from "shared/helper/utilitarioString";
import { formatarCpf, formatarNB } from "../../shared/helper/formatadores";
import { imprimirCarteira } from "./actions";
import { openDrawer } from '../../shared/template/drawerPDF/actions';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import AppFooter from "shared/template/AppFooter";
import ButtonAppBar from "shared/template/AppTitle";
import dayjs from 'dayjs';
import history from "../../history";
import LoadingCircular from "shared/template/LoadingCircular";
import MeuInssDescricao from "shared/template/MeuINSSDescricao";
import meuinssmais from "../../assets/img/meu_inss_mais.svg";
import QRCode from "../../shared/component/QRCode";
import "./CarteiraDigital.css";

const CarteiraDigital = (props) => {
  const dispatch = useDispatch();

  const {
    code,
    foto,
    validade,
    urlValidacao,
    beneficiosCarteira,
    esperandoSolicitacao,
  } = useSelector((state) => state.carteira);

  const { usuario } = useSelector((state) => state.session);

  const downloadCarteira = () => {
    trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.FUNCIONALIDADE, "Download Carteira Beneficiario");
    dispatch(openDrawer(() => dispatch(imprimirCarteira(code))));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (esperandoSolicitacao) {
    return <LoadingCircular />
  }

  return (
    <>
      <div className="carteira-root">
        <div className="carteira-div-background-img">
          <div className="carteira-div-container">
            <div className="carteira-header-container">
              <div className="carteira-inss-logo" />
              <div className="carteira-header-info">
                <p className="carteira-ministry-title">
                  <strong>MINISTÉRIO DA PREVIDÊNCIA SOCIAL</strong>
                </p>
                <p className="carteira-inss-title">
                  INSTITUTO NACIONAL DO SEGURO SOCIAL
                </p>
              </div>
            </div>

            <div className="carteira-img-qr-code">
              <img
                id="output"
                src={foto}
                className="carteira-img"
                alt=""
              />
              <div className="carteira-qr-container">
                <QRCode
                  className="carteira-canvas-qr-code"
                  text={`${urlValidacao}?code=${code}`}
                  size={80}
                />
                <p className="carteira-info-texto-qr-code carteira-black-text">
                  QR Code para consulta dos dados atualizados
                </p>
              </div>
            </div>

            <div>
              <p className="carteira-label-title">
                Beneficiário:
              </p>
              <p className="carteira-doc-title carteira-black-text">
                CPF: {formatarCpf(usuario.cpf)}
              </p>
              <p className="carteira-beneficiary-name carteira-black-text">
                {capitalize(usuario.nome)}
              </p>
            </div>
            <div>
              <div className="carteira-benefits-section">
                <p className="carteira-label-title">
                  Benefício(s):
                </p>
              </div>
            </div>
            {beneficiosCarteira
              ?.sort((a, b) => formataEspecieBeneficio(a.especie).localeCompare(formataEspecieBeneficio(b.especie), "pt", { ignorePunctuation: true }))
              .map((beneficio, index) => (
                <div key={index + 1}>
                  <p className="carteira-doc-title carteira-black-text">
                    NB: {formatarNB(beneficio.numero)}
                  </p>
                  <div className="carteira-benefit-item">
                    <p className="carteira-info-title carteira-black-text">
                      {formataEspecieBeneficio(beneficio.especie)}
                    </p>
                  </div>
                </div>
              ))}
            <p className="carteira-emission-date carteira-black-text">
              Emitida em {dayjs().format("DD/MM/YYYY")}
            </p>
            {beneficiosCarteira && (
              <p className="carteira-emission-date carteira-black-text">
                Válida até {validade}
              </p>
            )}
            <div className="carteira-validity-container">
              <p className="carteira-info-texto-validade carteira-black-text">
                Não é válido como documento de identificação.
              </p>
            </div>

            <div className="carteira-logo-container">
              <img
                className="carteira-logo-inss-mais"
                src={meuinssmais}
                alt="logo-inss-mais"
                width={250}
                height={80}
              />
            </div>
          </div>
        </div>
      </div>

      <AppFooter
        secondaryText="Voltar"
        secondaryAction={() => {
          // o fluxo garante que essa tela será a primeira 
          // após a emissão da carteira
          history.replace("/")
        }}
        primaryAction={downloadCarteira}
        primaryText="Baixar Documento"
        textAlign="right"
      />
    </>
  )
}

export default CarteiraDigital;
